import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DeleteCarrierDialog = ({ carrier, api, onClose, onDone }) => {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setTyped(""); }, [carrier]);
  const go = async () => {
    setBusy(true);
    try {
      await api.delete(`/owner/carriers/${carrier.id}`, { params: { confirm: typed } });
      toast.success(`${carrier.name} deleted`);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not delete carrier");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!carrier} onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="max-w-md" data-testid="delete-carrier-dialog">
        <DialogHeader>
          <DialogTitle>Delete {carrier?.name}?</DialogTitle>
          <DialogDescription>This permanently deletes the carrier, all its loads, documents, invoices, brokers and settings, and every admin and driver login. It can't be undone.</DialogDescription>
        </DialogHeader>
        <div>
          <p className="text-sm text-slate-600 mb-1.5">Type <b>{carrier?.name}</b> to confirm</p>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={carrier?.name} data-testid="delete-carrier-confirm-input" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid="delete-carrier-cancel">Cancel</Button>
          <Button onClick={go} disabled={busy || typed.trim() !== carrier?.name} className="bg-rose-600 hover:bg-rose-700" data-testid="delete-carrier-confirm-btn">{busy ? "Deleting…" : "Delete forever"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
